<template>
        <div>
          {{projected}}
        </div>
			
</template>

  <script>
	  export default {
		  mounted() {
			 // console.log('Payslip started..');   
		  },
		  props: ['employee_id', 'fiscal_year', 'payslip_id', 'month'],
				 
   
		  data() {
			  
			  return {
				  emp_id: this.employee_id,  
                  fisc_year: this.fiscal_year, 
                  pslip_id: this.payslip_id, 
                  projected:'0',
                  current_headvalue:'0',
                  mnth:this.month,
			  }
		  },
		  
		  methods:{
		  

			  
			  getheadtaxabletotal: function()
			  {
  
						  axios.get(this.$api_url+'/get-head-taxable-total/'+this.emp_id+'/'+this.fisc_year+'/'+this.pslip_id+'/'+this.mnth , {
							  params: {
								  status: '',
							  }
					  }).then(function(response){
					  this.projected =response.data.projected;
  
  
				  }.bind(this));
			  },
              
              failed_request_recovery: function()
			  {
			       if(this.projected=='0')
                   {
                   //alert(1);
                   this.getheadtaxabletotal();
                   }
			  },
			  
  
		  },
		  created: function(){
		  
		     this.getheadtaxabletotal();
             setInterval(this.failed_request_recovery, 4000);

			 	
		  }
	  }
  </script>